import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Radio, Video, Calendar, Megaphone, MessageSquare, Eye, UserPlus, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

const CARDS = [
  { key: "cultes", label: "Cultes", icon: Video, to: "/admin/cultes", color: "from-blue-500 to-blue-700" },
  { key: "events", label: "Événements", icon: Calendar, to: "/admin/events", color: "from-emerald-500 to-emerald-700" },
  { key: "announcements", label: "Annonces", icon: Megaphone, to: "/admin/announcements", color: "from-amber-500 to-amber-700" },
  { key: "messages", label: "Messages", icon: MessageSquare, to: "/admin/messages", color: "from-purple-500 to-purple-700" },
  { key: "registrations", label: "Inscriptions", icon: UserPlus, to: "/admin/registrations", color: "from-pink-500 to-pink-700" },
  { key: "total_views", label: "Vues cultes", icon: Eye, to: "/admin/cultes", color: "from-cyan-500 to-cyan-700" },
];

export default function AdminOverview() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="mb-8">
        <div className="text-gold-dark text-xs tracking-[0.3em] uppercase">Vue d'ensemble</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-deepblue-900 mt-1">Tableau de bord</h1>
        <p className="text-slate-500 mt-2">Gérez votre église en un coup d'œil.</p>
      </div>

      <div className={`rounded-2xl p-6 mb-8 border ${stats?.is_live ? "bg-red-50 border-red-200" : "bg-white border-slate-200"}`} data-testid="live-status-card">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${stats?.is_live ? "bg-red-500 text-white" : "bg-slate-100 text-slate-500"}`}>
              <Radio className={`w-5 h-5 ${stats?.is_live ? "live-dot" : ""}`} />
            </div>
            <div>
              <div className="font-serif text-lg text-deepblue-900">
                {stats?.is_live ? "Diffusion en direct active" : "Aucune diffusion en cours"}
              </div>
              <div className="text-sm text-slate-500">
                {stats?.is_live ? "Le lecteur du direct est visible sur le site public." : "Activez le direct depuis la section Direct."}
              </div>
            </div>
          </div>
          <Link to="/admin/live" data-testid="manage-live-link"
            className="px-4 py-2 rounded-full bg-deepblue-900 text-white text-sm hover:bg-deepblue-800 transition-colors">
            Gérer
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`}
            className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200 p-6 card-lift">
            <div className={`absolute -top-8 -right-8 w-32 h-32 rounded-full bg-gradient-to-br ${c.color} opacity-10 group-hover:opacity-20 transition-opacity`} />
            <div className="relative flex items-start justify-between">
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-400">{c.label}</div>
                <div className="mt-2 font-serif text-4xl text-deepblue-900">
                  {stats ? (stats[c.key] ?? 0) : "—"}
                </div>
              </div>
              <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${c.color} text-white flex items-center justify-center`}>
                <c.icon className="w-5 h-5" />
              </div>
            </div>
            {c.key === "messages" && stats?.unread_messages > 0 && (
              <div className="mt-3 inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-red-50 text-red-700 border border-red-200">
                <AlertCircle className="w-3 h-3" />
                {stats.unread_messages} non lus
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
